import { jsx } from "react/jsx-runtime";
import Script from "next/script";
import PropTypes from "prop-types";
import "react";
const HighTouchScript = ({
  storageEnvironment
}) => {
  const API_HOST = "us-east-1.hightouch-events.com";
  const highTouchStorageConfiguration = {
    Zillow: {
      writeKey: "d7ca45bd0240f34b8fc62c9436a1996722c225bd6dbabc187c0717726251ac52"
    },
    ZillowB2B: {
      writeKey: "d81be4ae7876e1d4ed4c99d3145885818d0aed240c35a84a0988d236386864d1"
    },
    ZillowHomeLoans: {
      writeKey: "1e925a8822f8167e6f8ed781bcc3ca42f81da4dbf4fd16e83084d5dee6c30496"
    },
    ZillowSandBox: {
      writeKey: "e3336c9f4499d96c559cd1fd4d2c981cdbaf702a30e070cea12873cfd94a0a13"
    }
  };
  const {
    writeKey
  } = highTouchStorageConfiguration[storageEnvironment];
  return /* @__PURE__ */ jsx(Script, { id: `hightouch_${storageEnvironment}`, type: "text/javascript", children: `
        !function(){var e=window.htevents=window.htevents||[];if(!e.initialize)if(e.invoked)window.console&&console.error&&console.error("Hightouch snippet included twice.");else{e.invoked=!0,e.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"],e.factory=function(t){return function(){var n=Array.prototype.slice.call(arguments);return n.unshift(t),e.push(n),e}};for(var t=0;t<e.methods.length;t++){var n=e.methods[t];e[n]=e.factory(n)}e.load=function(t,n){var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src="https://cdn.hightouch-events.com/browser/release/v1-latest/events.min.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(o,r),e._loadOptions=n,e._writeKey=t},e.SNIPPET_VERSION="0.0.1",
        e.load('${writeKey}',{apiHost:'${API_HOST}'}),
        e.page()}}();
        ` });
};
HighTouchScript.propTypes = {
  storageEnvironment: PropTypes.string.isRequired
};
export {
  HighTouchScript as default
};
